<wa-image-wrapper imagePublicId="{{ imagePublicId }}" alt="{{ alt }}">
</wa-image-wrapper>
